export default class BackgroundWrap {
  constructor() {
    this.selector = '.b-background-wrap';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.moveSectionsInsideBlock();
  }

  moveSectionsInsideBlock() {
    if (this.wrappers.length === 0) {
      return;
    }

    this.wrappers.forEach(wrapper => {
      const $wrapper = $(wrapper);
      const { sectionCount } = wrapper.dataset;

      if (this.sectionCount === 0) {
        return;
      }

      const $activeSections = $wrapper.nextAll('section').slice(0, sectionCount);

      $wrapper.append($activeSections);
    });
  }
}
